import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
import { Tenant } from '../../types';

interface SwitchContextType {
  selectedTenant: Tenant;
  setSelectedTenant: React.Dispatch<React.SetStateAction<Tenant>>;
}

const SwitchContext = createContext<SwitchContextType | undefined>(undefined);

export const useSwitchContext = () => {
  const context = useContext(SwitchContext);
  if (!context) {
    throw new Error('useSwitchContext must be used within a SwitchProvider');
  }
  return context;
};

// Provider component to wrap your application and provide the context
export const SwitchContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [selectedTenant, setSelectedTenant] = useState<Tenant>(Tenant.DE);

  return <SwitchContext.Provider value={{ selectedTenant, setSelectedTenant }}>{children}</SwitchContext.Provider>;
};
